import { render, staticRenderFns } from "./course-repair-logistics.vue?vue&type=template&id=5ed39739&scoped=true&"
import script from "./course-repair-logistics.vue?vue&type=script&lang=js&"
export * from "./course-repair-logistics.vue?vue&type=script&lang=js&"
import style0 from "./course-repair-logistics.vue?vue&type=style&index=0&id=5ed39739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed39739",
  null
  
)

export default component.exports